import { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { useBoolean, useCounter, useMedia } from 'react-use'
import useAnalyticsEventTracker from '../lib/useAnalyticsEventTracker.jsx';
import {ProductArray} from '../lib/useAnalyticsEventTracker.jsx';



import data from './data'

const AppContext = createContext()

const { Provider } = AppContext

const products = data.reduce((p, group, id) => {
  const { name: groupName, abbr, products } = group
  return [...p, ...products.map((product) => ({ groupName, abbr, groupId: id, ...product }))]
}, [])


//console.log(products);

const initialView = "timeline"
//process.env.NODE_ENV === 'development' ? 'landing' : 'landing'



// GET Product index from AppProvider
const CanvasContext = createContext(null);

const CanvasProvider = ({ children }) => {
  // est ce qu'on est sur la page 3D ?
  const [CanvasState, setCanvasState] = useState(false);
  // quel id d'animation on est en train player
  const [seqId,setSequenceId] = useState(false)
  // determine le nom du boutton a charger
  const [seqName,setSequenceName] = useState("")
  // determine la longuer de la prochaine animation
  const [seqTime,setSequenceTime] = useState(0)

  const [isStickText, setStickText] = useState(false);

  const [isTouchMode, setTouchMode] = useState(true)

  const [openImage, setOpenImage] = useState('')

  const [isOptionPanelOpen, setOpenOptionPanel] = useState(false)

 

  const playNextSeqence = useCallback(() => {
    //console.log("PLAY SEQUENCE...",seqId)
    setSequenceId((seqId) => !seqId);
    //console.log(".....",seqId)
  }, [seqId]);


  // On recois depuis l'AOS qu'on a changer d'image
  function handleMyValueChange(event) {
    setOpenImage(event.detail)
  }
  
  window.addEventListener('OpenImageAOS', handleMyValueChange);

   // On recois depuis l'AOS si on a ouvert le panneau des option (Hack grace au zoom)
   function handleOpenOptionPanel(event) {
    setOpenOptionPanel(event.detail)
  }
  
  window.addEventListener('OpenOptionPanelAOS', handleOpenOptionPanel);


  return (
    <CanvasContext.Provider value={{ CanvasState, 
                  setCanvasState,
                  playNextSeqence,
                  setStickText,
                  isStickText,
                  isTouchMode,
                  setTouchMode,
                  openImage,
                  setOpenImage,
                  isOptionPanelOpen,
                  setOpenOptionPanel,
                  seqId,
                  setSequenceId,
                  setSequenceName,
                  seqName,
                  seqTime,
                  setSequenceTime}}>
      {children}
    </CanvasContext.Provider>
  );
};


const useCanvas = () => useContext(CanvasContext);
export {CanvasProvider,useCanvas}

const AppProvider = ({ children }) => {
  
  const [currentView, setCurrentView] = useState(initialView)
  const [selectedProductIndex, setSelectedProductIndex] = useState(0)
  const [selectedFeature, setSelectedFeature] = useState()
  const [showFeatures, toggleFeatures] = useBoolean(false)
  const [ loadCount, { inc, dec, get, set, reset } ] = useCounter(0)
  const { gameState, setCanvasState } = useCanvas();
  const gaEventTracker = useAnalyticsEventTracker('Kmore');


  useEffect(() => {

    if(currentView !== "landing"){
      if(showFeatures === true){
      gaEventTracker('KnowMoreOpened at : ' + ProductArray[selectedProductIndex])
      }else{
        gaEventTracker('KnowMoreOpened at : ' + ProductArray[selectedProductIndex])
      }
    }

}, [showFeatures, currentView])


useEffect(() => {

  if(currentView !== "landing"){
    gaEventTracker('User displayed : ' + ProductArray[selectedProductIndex])
  }

}, [selectedProductIndex, currentView])


 

  const isShort = useMedia(`(max-height: 950px)`)
  const isPortrait = useMedia(`(max-width: 1023px)`)

  useEffect(() => {
    setSelectedFeature()
    if (selectedProductIndex === 8){
      setCanvasState(true)
    }else{
      setCanvasState(false)
    }
  }, [selectedProductIndex, setSelectedFeature])

  const loadInc = useCallback(
    (val) => {
      inc(val)
    },
    [inc]
  )





  const setSelectedProduct = useCallback(
    (index) => {
      setSelectedProductIndex(index)
    },
    [setSelectedProductIndex]
  )

  function goHome(){
    window.location.reload()
    /*
    reset(0)
    setSelectedProductIndex(0)
    setCurrentView('landing')
    // si on est connecter et on revient on efface le qrcode
    if (!window.utalk.touchenabled){
      window.utalk.imgqr = ""
    }
    */
  }

  const selectedProduct = products[selectedProductIndex]
  const isReady = true;
  //console.log(loadCount)

  /*
  if(window.utalk.productcheck){
    var shouldupdate = true;
  }else{
    var shouldupdate = false;
  }
*/


  return (
    <Provider
      value={{
        data,
        products,
        currentView,
        setCurrentView,
        selectedProductIndex,
        setSelectedProduct,
        selectedFeature,
        setSelectedFeature,
        selectedProduct,
        showFeatures,
        toggleFeatures,
        loadInc,
        isReady,
        isShort,
        isPortrait,
        goHome,

      }}
    >
      {children}
    </Provider>
  )
}

export const useApp = () => useContext(AppContext)

export default AppProvider
